/**
 * 模块名称: 待结算列表 => 费用订单列表页 => 结算弹窗
 * @author liujingxue@372163.com
 */

import React, { useState, useEffect, useRef } from 'react'
import api from '@/api'
import {
	Form,
	Icon,
	Upload,
	Select,
	DatePicker,
} from 'antd'
import { upLoadModule } from '@/utils/common'
import BtnGroup from '@/components/BtnGroup'
import moment from 'moment'

const { Dragger } = Upload
const FormItem = Form.Item
const dateFormat = 'YYYY-MM-DD'

const ClosingModal = (props) => {
	const { closing, setVisibleClosing, getEmployeeList } = props
	const { getFieldDecorator, validateFields } = props.form
	const draggerRef = useRef(null)
	const [fileList, setFileList] = useState([])
	const [payAccounts, setPayAccounts] = useState([])

	useEffect(() => {
    const { companyId } = closing
		api.getCorporateAccountlist({ limit: 99999, corpId: companyId }).then((data) => {
			setPayAccounts(Array.isArray(data.list) ? data.list : [])
		}).catch(() => setPayAccounts([]))
	}, [])

	const formSubmit = (e) => {
		e.preventDefault()
		validateFields((err, vals) => {
			let uploadList = []
			for (let i = 0, k = fileList.length; i < k; i++) {
				if (fileList[i].status !== 'removed') {
					uploadList.push({
						url: fileList[i].url,
						name: fileList[i].name
					})
				}
			}
			if (!err) {
				let submitValues = { ...vals }
				const { paymentNumber, payTime, ...restValues } = submitValues
					if (paymentNumber) {
					const [accountNo, bank] = paymentNumber.split('|')
					submitValues = {
						...restValues,
						payTime: payTime.format(dateFormat),
						payAccountNo: accountNo || '',
						payBank: bank || '',
					}
				}
				api.setOfficeCostManagementSettlement({
					id: closing.id,
					receipt: JSON.stringify(uploadList),
					...submitValues
				}).then(res => {
					setVisibleClosing(false)
					getEmployeeList()
				}).catch(err => console.log(err))
			}
		})
	}

	// 文件上传 
	const uploadFiles = upLoadModule({
		fileList: fileList,
		setFileList: setFileList,
		draggerRef: draggerRef,
		accept: '.png, .jpg, .PDF',
		allowSizeType: 2
	})

	const formItemLayout = {
		labelCol: {
			span: 6
		},
		wrapperCol: {
			span: 18
		}
	}

	return (
		<Form onSubmit={formSubmit} {...formItemLayout}>
			<FormItem label="业务编号">
				<div>{closing.id}</div>
			</FormItem>
			<FormItem label="付款金额">
				<div>{closing.money}</div>
			</FormItem>
			<FormItem label="公司主体">
				<div>{closing.companyName}</div>
			</FormItem>
			<FormItem label="收款单位">
				<div>{closing.payee}</div>
			</FormItem>
			<FormItem label="收款开户行">
				<div>{closing.bankName}</div>
			</FormItem>
      <FormItem label="收款账号">
				<div>{closing.bankAccount}</div>
			</FormItem>
			<FormItem label="银行支付日期">
				{getFieldDecorator('payTime', {
						initialValue: moment(new Date(), dateFormat),
						rules: [{ required: true, message: '请输入银行支付日期' }]
				})(
						<DatePicker placeholder="请选择" />
				)}
			</FormItem>
			<FormItem label='付款账号'>
				{getFieldDecorator('paymentNumber', {
					rules: [{ required: true, message: '请选择付款账号' }],
				})(
					<Select
						placeholder='请选择'
						dropdownMatchSelectWidth={false}
						showSearch
						className='pay-account-select'
						optionFilterProp='label'
						allowClear
					>
						{payAccounts.map((item) => (
							<Select.Option
								key={item.id}
								value={`${item.accountNo}|${item.bank}`}
								label={`${item.accountNo}\n${item.bank}`}
							>
								<div>
									<div>{item.accountNo}</div>
									<div>{item.bank}</div>
								</div>
							</Select.Option>
						))}
					</Select>
				)}
			</FormItem>
			<FormItem label="付款凭证" >
				<div className="dragger-box" ref={draggerRef} style={{ position: 'relative' }}>
					<Dragger
						{...uploadFiles}
					>
						<p className="ant-upload-drag-icon">
							<Icon type="inbox" />
						</p>
						<p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
						<p className="ant-upload-hint">
							支持扩展名：.png, jpg, .pdf 单个文件大小不超过5M。
						</p>
					</Dragger>
				</div>
			</FormItem>
			<BtnGroup cancelName="取消" confirmName="确认" onConfirm={formSubmit} onCancel={() => setVisibleClosing(false)} />
		</Form>
	)
}

export default Form.create()(ClosingModal)